"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSrcPlane = void 0;
var getSrcPlane = function (chart, dimension) {
    if (dimension === void 0) { dimension = 0; }
    var valuesGroup = chart.values.map(function (it) { return it.series; });
    var values = Array.from(new Array(valuesGroup[0].length))
        .map(function (_, i) { return Array.from(new Array(valuesGroup.length))
        .map(function (__, j) { return valuesGroup[j][i]; })
        .reduce(function (acc, it) { return acc + it; }, 0); });
    var min = chart.yAxis.zeroBased ? 0 : Math.min.apply(Math, values);
    var max = Math.max.apply(Math, values);
    var padValue = (max - min) / 10;
    min = chart.yAxis.zeroBased ? min : Math.round((min - padValue) * 100) / 100;
    max = Math.round((max + padValue) * 100) / 100;
    return [
        [
            [
                0,
                0
            ],
            [
                chart.xAxis.series.length,
                0
            ]
        ],
        [
            [
                0,
                min
            ],
            [
                0,
                max
            ]
        ],
    ];
};
exports.getSrcPlane = getSrcPlane;
